import React, { useState } from "react";
import { connect } from "react-redux";
import { Form, Input, Button, Spin, Divider, Modal, List, message } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { GoogleLogin } from "@react-oauth/google";
import { bindActionCreators } from "redux";

// import APIs and functions
import PhysicianApi from "../../../../axios/physician/PhysicianApi";
import authentication from "../../../../redux/authentication";
import { useAuthentication } from '../../../../context/AuthProvider';

//import components
import ForgetPasswordCompent from "../../../../components/ForgetPasswordComponent/ForgetPasswordComponent";

function LoginPhysician(props) {
  const { actions } = props;
  const [disable, setDisable] = useState(false);
  const [spinning, setSpinning] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [forgetPasswordModalVisible, setForgetPasswordModalVisible] = useState(
    false
  );
  const [accountCandidates, setAccountCandidates] = useState(null);
  const [pendingCredential, setPendingCredential] = useState(null);
  const { login, googleLogin } = useAuthentication();

  const handleGoogleSuccess = async (credential, selectedUserId) => {
    try {
      const result = await googleLogin(credential, selectedUserId);
      if (result?.candidates) {
        setPendingCredential(credential);
        setAccountCandidates(result.candidates);
      }
    } catch {
      // error already surfaced by googleLogin
    }
  };

  const handleAccountSelection = (userId) => {
    handleGoogleSuccess(pendingCredential, userId);
    setAccountCandidates(null);
    setPendingCredential(null);
  };

  const cancelAccountPicker = () => {
    setAccountCandidates(null);
    setPendingCredential(null);
  };
  const onFinish = async (values) => {
    setDisable(true);
    setSpinning(true);
    return login({ email: values.username, password: values.password }).catch(submitComplete);
  };
  const submitComplete = () => {
    setDisable(false);
    setSpinning(false);
  };

  const onForgetPasswordFinish = (values) => {
    setFormLoading(true);
    PhysicianApi.passwordResetRequest({
      ...values,
    })
      .then((res) => {
        const { data } = res;
        if (data && data.success) {
          message.success(
            "Successfully identified your account and initiated password reset! Reset link has been sent to your Email"
          );
          setForgetPasswordModalVisible(false);
        } else {
          if (data && data.message) {
            message.error(data.message);
          } else {
            message.error(
              "Failed to find you account! Please check your email"
            );
          }
        }
        setFormLoading(false);
      })
      .catch(() => {
        message.error(
          "Failed to find your account! Please check your email or try again later"
        );
        setFormLoading(false);
      });
  };

  const handleForgetPasswordLink = () => {
    setForgetPasswordModalVisible(true);
  };

  const closeResetPasswordModal = () => {
    setForgetPasswordModalVisible(false);
  };

  return (
    <div>
      <div className="login-selection-part-login-signup">
        <p>Login</p>
      </div>

      <Form name="basic" layout="vertical" size="large" onFinish={onFinish}>
        <Form.Item
          name="username"
          rules={[
            {
              type: "email",
              message: "The input is not valid E-mail!",
            },
            {
              required: true,
              message: "Please input your E-mail!",
            },
          ]}
        >
          <Input id="login-email-input" placeholder="Email ID" />
        </Form.Item>

        <Form.Item
          name="password"
          rules={[
            {
              required: true,
              message: "Please input your password!",
            },
          ]}
        >
          <Input.Password id="login-password-input" placeholder="Password" />
        </Form.Item>

        <Form.Item>
          <Spin spinning={spinning} indicator={<LoadingOutlined />}>
            <Button
              id="login-submit-btn"
              type="primary"
              htmlType="submit"
              style={{ width: "100%" }}
              disabled={disable}
            >
              <b>LOGIN</b>
            </Button>
          </Spin>
        </Form.Item>

        <Form.Item className="wrapper-text-align">
          <Button
            id="login-forgot-password-link"
            className="user-button-link"
            type="link"
            onClick={handleForgetPasswordLink}
          >
            Forgotten password?
          </Button>
        </Form.Item>
      </Form>
      <Divider plain>or</Divider>
      <div style={{ display: "flex", justifyContent: "center", marginBottom: 16 }}>
        <GoogleLogin
          onSuccess={(credentialResponse) => {
            handleGoogleSuccess(credentialResponse.credential);
          }}
          onError={() => {
            message.error("Google sign-in failed");
          }}
          text="signin_with"
          shape="rectangular"
          size="large"
        />
      </div>
      <Modal
        open={!!accountCandidates}
        title="Select an account"
        maskClosable={false}
        onCancel={cancelAccountPicker}
        footer={null}
        centered
        destroyOnClose
      >
        <List
          dataSource={accountCandidates || []}
          renderItem={(candidate) => (
            <List.Item
              actions={[
                <Button
                  type="primary"
                  onClick={() => handleAccountSelection(candidate._id)}
                >
                  Select
                </Button>,
              ]}
            >
              <List.Item.Meta
                title={`${candidate.firstName || ""} ${candidate.lastName || ""}`.trim() || candidate.email}
                description={
                  <>
                    <div>{candidate.email}</div>
                    {candidate.userType && <div>{candidate.userType}</div>}
                  </>
                }
              />
            </List.Item>
          )}
        />
      </Modal>
      <ForgetPasswordCompent
        modalVisible={forgetPasswordModalVisible}
        loading={formLoading}
        setModalVisible={closeResetPasswordModal}
        handlePasswordResetRequest={onForgetPasswordFinish}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  const { loggingIn } = state.authentication;
  return { loggingIn };
};

const mapDispatchToProps = (dispatch) => {
  const { login } = authentication.actions;
  return {
    actions: bindActionCreators(
      {
        login,
      },
      dispatch
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPhysician);
